import React from 'react';

import './oe-toggle.scss';

interface IProps {
    isSelected: boolean;
    onClick?: () => void;
    isDisabled?: boolean;
    dataTestId?: string;
    className?: string;
}

const OEToggle = (props: IProps) => {
    const { isSelected, onClick, isDisabled, dataTestId, className } = props;
    const switchClassName = className ? 'switch ' + className : 'switch';
    return (
        <label className={switchClassName}>
            <input type='checkbox' checked={isSelected} readOnly disabled={isDisabled} data-test-id={dataTestId}/>
            <span
                className={`slider round ${isDisabled ? 'disabled' : ''}`}
                onClick={() => !isDisabled ? onClick() : undefined}
            >
            </span>
        </label >
    );
};

export { OEToggle };
